'use client';

import React from 'react';
import { TasticProps } from '../types';
import ContentStrip from 'components/commercetools-ui/organisms/content-strip';
import { ButtonVariant } from 'components/commercetools-ui/atoms/button';
import { Reference } from 'types/reference';

interface ContentStripTasticProps {
  title: string;
  description?: string;
  buttonText?: string;
  buttonLink?: Reference;
  buttonVariant?: ButtonVariant;
  mediaType: 'video' | 'image';
  image?: any;
  mediaSrc?: string;
  mobilePosition?: 'media-top' | 'media-bottom';
  tabletPosition?: 'media-top' | 'media-bottom' | 'media-left' | 'media-right';
  desktopPosition?: 'media-top' | 'media-bottom' | 'media-left' | 'media-right';
  theme?: 'dark' | 'white';
}

const ContentStripTastic = ({ data }: TasticProps<ContentStripTasticProps>) => {
  return (
    <ContentStrip
      title={data.title}
      description={data.description}
      buttonText={data.buttonText}
      buttonLink={data.buttonLink}
      buttonVariant={data.buttonVariant}
      mediaType={data.mediaType}
      image={data.image}
      mediaSrc={data.mediaSrc}
      mobilePosition={data.mobilePosition}
      tabletPosition={data.tabletPosition}
      desktopPosition={data.desktopPosition}
      theme={data.theme}
    />
  );
};

export default ContentStripTastic;
